package one.healthium.insights.ui.components

import androidx.compose.runtime.Composable
import androidx.compose.ui.text.TextLinkStyles
import com.mikepenz.markdown.model.DefaultMarkdownTypography
import one.healthium.ui.compose.theme.AppTheme

@Composable
fun defaultMarkdownTypography(): DefaultMarkdownTypography {
    return DefaultMarkdownTypography(
        text = AppTheme.textStyles.body,
        paragraph = AppTheme.textStyles.body,
        ordered = AppTheme.textStyles.body,
        bullet = AppTheme.textStyles.body,
        list = AppTheme.textStyles.body,
        h1 = AppTheme.textStyles.poppins32,
        h2 = AppTheme.textStyles.poppins24,
        h3 = AppTheme.textStyles.poppins20,
        h4 = AppTheme.textStyles.secondary_16_400,
        h5 = AppTheme.textStyles.secondary_14_400,
        h6 = AppTheme.textStyles.secondary_12_400,
        code = AppTheme.textStyles.secondary_14_400,
        inlineCode = AppTheme.textStyles.secondary_14_400,
        quote = AppTheme.textStyles.secondary_16_400,
        table = AppTheme.textStyles.body,
        textLink = TextLinkStyles(),
    )
}